module.exports = __webpack_public_path__ + "img/bette-browser-update.5aff7df.jpeg";